import { render, staticRenderFns } from "./endFlow.vue?vue&type=template&id=407a31b6&"
import script from "./endFlow.vue?vue&type=script&lang=js&"
export * from "./endFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports